module.exports = __webpack_public_path__ + "static/img/Vision Rig_2x3.86307c1b.webp";